import PropTypes from 'prop-types';
import {useMediaQuery} from '@mui/material';
import {styled} from '@mui/material/styles';
import {MobileNav} from '../mobile-nav';
import {SideNav} from './side-nav';
import {TopNav} from './top-nav';
import {useMobileNav} from './use-mobile-nav';
import {useSideNav} from "./use-side-nav";
import {SIDE_NAV_MINI_WIDTH, SIDE_NAV_WIDTH} from "src/layouts/app";


const VerticalLayoutRoot = styled('div', {shouldForwardProp: (prop) => prop !== 'open'})(({theme, openSideNav}) => ({
    display: 'flex',
    flex: '1 1 auto',
    maxWidth: '100%',
    transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
    }),
    [theme.breakpoints.up('lg')]: {
        paddingLeft: SIDE_NAV_MINI_WIDTH
    },
    ...(openSideNav && {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        [theme.breakpoints.up('lg')]: {
            paddingLeft: SIDE_NAV_WIDTH
        },

    })
}));

const VerticalLayoutContainer = styled('div')({
    display: 'flex',
    flex: '1 1 auto',
    flexDirection: 'column',
    width: '100%'
});

export const VerticalLayout = (props) => {
    const {children, sections, navColor} = props;
    const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'));
    const mobileNav = useMobileNav();
    const sideNav = useSideNav();

    return (
        <>
            <TopNav onMobileNavOpen={mobileNav.handleOpen}
                    openSideNav={sideNav.open}
            />
            {lgUp && (
                <SideNav
                    color={navColor}
                    sections={sections}
                    onClose={sideNav.handleClose}
                    onOpen={sideNav.handleOpen}
                    open={sideNav.open}
                    sideNavAction={sideNav}
                />
            )}
            {!lgUp && (
                <MobileNav
                    color={navColor}
                    onClose={mobileNav.handleClose}
                    open={mobileNav.open}
                    sections={sections}
                />
            )}
            <VerticalLayoutRoot openSideNav={sideNav.open}>
                <VerticalLayoutContainer>
                    {children}
                </VerticalLayoutContainer>
            </VerticalLayoutRoot>
        </>
    );
};

VerticalLayout.propTypes = {
    children: PropTypes.node,
    navColor: PropTypes.oneOf(['blend-in', 'discreet', 'evident']),
    sections: PropTypes.array
};
